<template>
  <spinner v-if="loading" />
  <div
    v-else
    class="wrapper crm-layout"
    :class="[{ 'nav-open': $sidebar.showSidebar }]"
  >
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu />
      <template slot="links">
        <sidebar-item
          v-if="canGetListOfLeads"
          :link="{
            name: 'Lista zamówień',
            icon: 'assignment',
            path: '/orders',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="canGetListOfUsers"
          :link="{
            name: 'Użytkownicy',
            icon: 'supervisor_account',
            path: '/users',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="canCreateRole"
          :link="{
            name: 'Role i uprawnienia',
            icon: 'security',
            path: '/roles',
          }"
        >
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <notifications />
      <top-navbar />
      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view />
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter" />
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import { mapGetters } from 'vuex'

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`)
    document.getElementsByClassName(className)[0].scrollTop = 0
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className)
    }, 100)
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList
  let isWindows = navigator.platform.startsWith('Win')
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar('sidebar')
    initScrollbar('sidebar-wrapper')
    initScrollbar('main-panel')

    docClasses.add('perfect-scrollbar-on')
  } else {
    docClasses.add('perfect-scrollbar-off')
  }
}

import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import UserMenu from '@/layouts/Extra/UserMenu.vue'

export default {
  components: {
    TopNavbar,
    ContentFooter,
    UserMenu,
  },
  data() {
    return {
      loading: true,
      sidebarBackgroundColor: 'black',
      sidebarBackground: 'green',
      sidebarBackgroundImage: './img/sidebar-2.jpg',
      sidebarMini: true,
      sidebarImg: true,
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },
    async setup() {
      // eslint-disable-next-line no-unused-vars
      await this.$store.dispatch('getUserData').catch(error => {
        this.$router.push({ name: 'logout' })
      })
      await this.$store.dispatch('fetchRoles')
      this.loading = false
    },
  },
  computed: {
    ...mapGetters(['canGetListOfUsers', 'canGetListOfLeads', 'canCreateRole']),
  },
  updated() {
    reinitScrollbar()
  },
  mounted() {
    reinitScrollbar()
    this.setup()
  },
  created() {},
  watch: {
    sidebarMini() {
      this.minimizeSidebar()
    },
  },
}
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
